<template>
  <div style="margin-left: 20px; position: relative; top:-8px; min-height: calc(100vh - 78px); max-height: calc(100vh - 78px);">
    <el-dialog v-if="isShowEditDiaglog" :visible.sync="isShowEditDiaglog" :destroy-on-close="true"
      :close-on-click-modal="false" width="500px">
      <h5>Nhập từ cấm thay thế:</h5>
      <el-input placeholder="Nội dung từ khóa" type="textarea" v-model="selectedCharaterFilter.content"
        :autosize="{ minRows: 6, maxRows: 7 }"></el-input>
      <div class="d-flex mt-3 g-0 justify-content-end">
        <el-button class="" size="mini" type="primary" @click="update"> Lưu</el-button>
        <el-button class="" size="mini" type="danger" @click="isShowEditDiaglog = false">Huỷ</el-button>
      </div>
    </el-dialog>
    <el-dialog title="THIẾT LẬP ÁP DỤNG TỪ KHÓA CẤM" v-if="isShowSetting" :visible.sync="isShowSetting"
      :destroy-on-close="true" :close-on-click-modal="false" width="404px">
      <div style="border: 1px solid #CED2D6AD; border-radius: 3px;">
        <div class="d-flex fw-700 font-size-13" style="background-color: #F4F5F9; color: #9497A5; padding: 8px 12px 8px 12px">
          <div class="col-9 col-md-9">Tài khoản zalo</div>
          <div class="col-3 col-md-3">Hành động</div>
        </div>
        <div class="flex-1 small-scrollbar">
          <div v-for="(acc, index) in app.accountSetting" :key="index">
            <div class="d-flex font-size-16" style="border-top: 1px solid #CED2D6AD; padding: 16px 12px 16px 12px">
              <div class="col-9 col-md-9">
                <div class="fw-bold">{{ acc.displayName }}</div>
                <div class="font-size-14 text-danger" v-if="acc.swName && acc.swName.length > 0">Biệt
                  danh : {{ acc.swName }}
                </div>
              </div>

              <div class="w-100px  justify-content-center text-center col-3 col-md-3">
                <el-tooltip class="item pointer mx-1" effect="dark" :content="contentActive(acc)" placement="top">
                  <el-switch v-model="acc.checkBadWord" @change="activeChange(acc)" />
                </el-tooltip>
                <div class="mx-1" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="custom-dialog"
      title="TẠO TỪ KHÓA CẤM BẰNG FILE EXCEL"
      :visible.sync="isShowExcelDialog"
      :destroy-on-close="true"
      width="500px"
      @close="handleCloseExcelDialog">
      <div style="border: 1px solid #ececec; padding: 10px; border-radius: 4px">
        <div
          class="d-flex"
          style="align-items: center; justify-content: space-between">
          <span class="custom-text text-left fw-bold">Mẫu Excel tạo từ khóa cấm hàng loạt</span>
          <el-button
            type="primary"
            @click="downloadExcel"
            style="background-color: white; color: #327ae7; height: 32px; width: 157px; display: flex; justify-content: center; align-items: center">
            <div
              class="d-flex"
              style="align-items: center">
              <icon-v-2
                name="v2-import"
                color="#327AE7"
                size="16px"
                style="margin-right: 8px; vertical-align: middle"></icon-v-2>
              <span style="color: #327ae7; font-size: 12px">Tải mẫu tạo hàng loạt</span>
            </div>
          </el-button>
        </div>
        <div
          class="mt-2"
          style="border-top: 1px solid #ececec; padding-top: 10px">
          <span class="custom-text text-left fw-bold">Chọn tài khoản áp dụng</span>
          <el-select
            class="custom-account"
            v-model="accountIdCreate"
            filterable
            default-first-option
            placeholder="Tìm kiếm tài khoản..."
            @change="changeCreateAccout()"
            style="
              width: 100%;
              height: 32px;
              gap: 0px;
              border-radius: 4px 0px 0px 0px;
              border: 1px 0px 0px 0px;
              justify: space-between;
              opacity: 0px;
              margin-top: 5px;
            ">
            <el-option
              label="Tất cả tài khoản"
              class="uppercase-label"
              :value="0"></el-option>
            <el-option
              v-for="account in app.accounts"
              :key="account.accountId"
              :label="account.swName || account.displayName"
              :value="account.accountId"></el-option>
          </el-select>
        </div>
        <div class="d-flex mt-3">
          <span class="text-left fw-bold me-2 pt-1">Chọn tệp tải lên</span>
          <el-upload
          class="upload"
            action=""
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :auto-upload="false"
            :file-list="fileList"
            accept=".xlsx, .xls">
            <el-input placeholder="Chọn file" size="small" style="width: 325px;">
              <template slot="append">Tìm</template>
            </el-input>
          </el-upload>
        </div>
      </div>
      <div
        class="d-flex justify-content-between align-items-center mt-3"
        style="margin-bottom: 5px">
        <div class="d-flex align-items-center">
          <icon-v-2
            name="v2-info1"
            color="#FDAF36"></icon-v-2>
          <span style="color: #7a7f83; margin-left: 3px">Chú ý: Tạo từ khóa cấm là từ đơn</span>
        </div>
        <div class="dialog-footer">
          <el-button @click="cancelExcelDialog">Hủy</el-button>
          <el-button
            type="primary"
            @click="handleSubmit">
            Tải lên
          </el-button>
        </div>
      </div>
    </el-dialog>
    <div class="d-flex" style="min-height: calc(100vh - 70px); max-height: calc(100vh - 70px);">
      <div style="width:500px;min-width: 300px; padding-right: 25px; border-right: 1px solid #CED2D6AD;">
        <div class="d-flex justify-content-between align-items-center my-2 py-1">
          <h4 class="mt-2 font-size-18 fw-bolder">Tạo từ khóa</h4>
          <el-button
            class="d-flex align-items-center font-size-14"
            @click="excelPopup"
            style="
              width: 134px;
              height: 36px;
              background-color: #3484f0;
              color: white;
              border-radius: 4px;
              border: 1px solid #3484f0;
              display: flex;
              align-items: center;
              justify-content: center;
            ">
            <div class="d-flex">
              <icon-v-2
                name="v2-import"
                color="white"
                style="margin-right: 8px; vertical-align: middle"></icon-v-2>
              Nhập file Excel
            </div>
          </el-button>
        </div>

        <el-select v-model="accountIdCreate" filterable default-first-option
          placeholder="Tìm kiếm tài khoản..." style="width: 100%;" class="mb-2">
          <el-option label="Tất cả tài khoản" :value="0"></el-option>
          <el-option v-for="account in app.accounts" :key="account.accountId" :label="account.swName || account.displayName"
            :value="account.accountId">
          </el-option>
        </el-select>

        <el-input placeholder="Từ khóa cấm là từ đơn" type="textarea" v-model="textContent"
          :autosize="{ minRows: 6, maxRows: 7 }"></el-input>
        <div class="font-size-14 mt-2" style=""><span style="color: red">*</span> Xuống dòng để thêm từ khoá mới</div>
        <el-button type="info" class="btn-action mt-2 w-100" @click="handleSubmit">Tạo từ khóa mới</el-button>
      </div>
      <div class="px-4" style="width: 100%; background-color: #ffffff;">
        <div class="d-flex mb-1 mt-1 justify-content-between align-items-center">
          <h6 class="my-3 font-size-18 fw-bolder" style="color: #373C41;"> Danh sách từ khoá đang lọc</h6>
          <div class="align-items-center">
            <el-input prefix-icon="el-icon-search" style="width: 200px;" class="me-2"
              v-model="searchKey" @input="searchChar()" placeholder="Tìm kiếm..." />
            <el-select v-model="accountId" @change="changeAccount()" filterable default-first-option
              placeholder="Tìm kiếm tài khoản..." style="width: 150px;" class="me-2">
              <el-option label="Tất cả tài khoản" :value="0"></el-option>
              <el-option v-for="account in app.accounts" :key="account.accountId" :label="account.swName || account.displayName"
                :value="account.accountId">
              </el-option>
            </el-select>
            <el-button icon="el-icon-setting" plain type="primary" @click="settingPopup()"></el-button>
          </div>
        </div>
        <div
          style="border: 1px solid #CED2D6AD; min-height: calc(100vh - 150px); max-height: calc(100vh - 150px); border-radius: 5px;">
          <div class="d-flex fw-700 font-size-14" style="background-color: #FAFAFA; color: #696B72; padding: 8px 12px 8px 12px; border-radius: 5px">
            <div class="col-8 col-md-6 ">Nội dung</div>
            <div class="col-2 col-md-3 ">Thời gian cập nhật</div>
            <div class="col-2 col-md-3 text-center">Hành động</div>
          </div>
          <div class="flex-1 small-scrollbar"
            style="overflow-y: auto;max-height:calc(100vh - 199px);overflow-x: hidden;">
            <div v-for="(item, index) in characterFilterShows" :key="index" class="font-size-16">
              <div class="d-flex" style="border-top: 1px solid #CED2D6AD; padding: 16px 12px 16px 12px">
              <div class="col-8 col-md-6 align-self-center" style="font-weight: 700;">{{ item.content }}</div>
              <div class="col-2 col-md-3 align-self-center" style="font-weight: 400; color: #696B72;">{{ convertTime(item.createAt) }}</div>
              <div class="col-2 col-md-3 text-center">
                <el-button
                  size="mini"
                  style="background-color: #1769d7; width: 28px; height: 28px; padding: 2px 0px 2px 0px; gap: 4px; border-radius: 4px; opacity: 0px"
                  @click="onEdit(item)">
                  <div>
                    <icon-v-2
                      name="fa fa-pen"
                      slot="prefix"
                      color="#ffffff"
                      size="13px" />
                  </div>
                </el-button>

                <el-button
                  size="mini"
                  @click="onDelete(item)"
                  style="background-color: #ffffff; width: 28px; height: 28px; padding: 2px 0px 2px 0px; gap: 4px; border-radius: 4px; opacity: 0px">
                  <icon-v-2
                    name="fa fa-trash"
                    color="#D91B1B"
                    size="13px"></icon-v-2>
                </el-button>
              </div>
              </div>
            </div>
            <div class="row divider-custom-zalo" />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { syncReadFile } from "../../lib/file";
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';

export default {
  name: "CharacterFilter",
  data() {
    return {
      accountId: 0,
      accountIdCreate: 0,
      selectedCharaterFilter: { id: 0, accountId: 0, content: "" },
      characterFilters: [],
      isShowEditDiaglog: false,
      isShowSetting: false,
      isShowExcelDialog: false,
      textContent: "",
      searchKey: "",
      characterFilterShows: [],
      fileList: [],
    };
  },
  methods: {
    contentActive(item) {
      if (item.checkBadWord) return "Tắt";
      return "Bật";

    },
    activeChange(item) {
      // item.checkBadWord = !item.checkBadWord;
      this.$http.post("/api/account/setting/save", item).then(() => {
        this.getAccountSetting();
      });
    },

    searchChar() {
      if (this.searchKey.length > 0) {
        this.characterFilterShows = this.characterFilters.filter(p => p.content.toLowerCase().includes(this.searchKey.toLowerCase()));
      } else {
        this.characterFilterShows = this.characterFilters;
      }
    },
    update() {
      const trimText = this.selectedCharaterFilter.content.trim();
      const validWord = (line) => {
          return /^[\p{L}\p{N}]+$/u.test(line);
      };

      if(!validWord(trimText) || this.isContainSpecialCharater(trimText)){
        this.alert("error", "Không được chứa từ không phải từ đơn hoặc ký tự đặc biệt.");
        return;
      }

      this.$http.put("/api/characterFilter", {
        id: this.selectedCharaterFilter.id,
        content: this.selectedCharaterFilter.content,
        accountId: this.selectedCharaterFilter.accountId
      }).then(() => {
        this.selectedCharaterFilter = { id: 0, accountId: 0, content: "" };
        this.isShowEditDiaglog = false;
        this.getCharacter();
        this.getAllCharacterFilter();
      }).catch((e) => {
        if (e.error.message === "exist") this.alertError("Nội dung từ khoá đã tồn tại");
      });
    },
    onEdit(item) {
      this.isShowEditDiaglog = true;
      this.selectedCharaterFilter = {...item};
    },
    settingPopup() {
      this.isShowSetting = true;
    },
    excelPopup() {
      this.isShowExcelDialog = true;
    },
    onDelete(item) {
      this.$confirm("Bạn muốn xoá từ khoá này?", "Warning", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning"
      }).then(async () => {
        this.$http.delete("/api/characterFilter", {
          params: {
            id: item.id,
            accountId: this.accountId
          }
        }).then(() => {
          this.getCharacter();
          this.getAllCharacterFilter();
        });
      });
    },
    isContainSpecialCharater(string) {
      var format = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
      return format.test(string);
    },
    createCharaterFilter(content) {
      this.$http.post("/api/characterFilter", {
        content: content,
        accountId: this.accountIdCreate,
        userId: this.app.user.id
      }).then((resp) => {
        this.alert("success", `Thêm thành công: ${resp.data.success}, Thêm thất bại: ${resp.data.fail}`);
        this.getCharacter();
        this.getAllCharacterFilter();
      });
    },
    async downloadExcel() {
      const dataTemplate = [
        'đm', 'cmm', 'vl'
      ];

      const ws = XLSX.utils.aoa_to_sheet(dataTemplate.map(item => [item]));

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Mẫu Dữ Liệu Từ Cấm');

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      saveAs(blob, 'mau-du-lieu.xlsx');
    },
    handleSubmit() {
      const textContentTrimmed = this.textContent.trim();
      const lines = textContentTrimmed.split('\n').filter(line => line.trim() !== '');

      const validWord = (line) => {
          return !/\s/.test(line);
      };

      const filteredLines = lines.filter(line => !validWord(line));
      

      if (filteredLines.length > 0) {
          this.alert("error", "Không được chứa từ không phải từ đơn.");
          return;
      }
      
      if (this.isContainSpecialCharater(textContentTrimmed)) {
        return this.alert("error", "Từ khoá không được chứa kí tự đặc biệt");
      }

      const uniqueLines = [...new Set(lines)];

      if (!textContentTrimmed) {
        this.alert("error", "Từ khoá rỗng");
        return;
      }
      
      const sameWord = lines.filter(line => this.isExistContentByAccountId(line, this.accountIdCreate));
      if(sameWord) this.alert("error", "Có từ khóa trùng");

      const cleanedTextContent = uniqueLines.join('\n');
      this.isShowExcelDialog = false; 
      this.createCharaterFilter(cleanedTextContent);
      this.textContent = "";
      this.fileUpload = null;
      this.$refs.file.value = null;
    },
    _syncReadFile(file, callback) {
      return syncReadFile(file, callback);
    },
    onChange() {
      this.fileUpload = this.$refs.file.files[0];
      this._syncReadFile(this.fileUpload, text => {
        text = text.trim().replace(/(\s)+/g, "$1");
        this.textContent = text;
      });
    },
    changeAccount() {
      this.getCharacter();
    },
    changeCreateAccout() {
      if(this.fileList.length > 0){
        this.handleFileChange(null, this.fileList);
      }
    },
    getCharacter() {
      this.$http.get("/api/characterFilter", {
        params: {
          accountId: this.accountId,
          searchKey: this.searchKey
        }
      }).then(resp => {
        this.characterFilters = resp.data;
        this.characterFilters = this.characterFilters.sort((s, s1) => new Date(s1.createAt).getTime() - new Date(s.createAt).getTime());
        this.characterFilterShows = this.characterFilters;
        this.searchChar();
      });
    },
    handleFileRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleFileChange(file, fileList) {
      if (fileList.length > 1) {
        this.fileList = [fileList[fileList.length - 1]];
        this.alert("success", "Đã nhận file mới nhất");
      } else {
        this.fileList = fileList;
      }

      this.textContent = '';
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const arrayBuffer = e.target.result;
          const workbook = XLSX.read(arrayBuffer, { type: 'array' });

          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          if (!worksheet) {
            this.alert("error", "Không tìm thấy worksheet trong file.");
            return;
          }
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
          if (jsonData.length === 0) {
            this.alert("error", "File không chứa dữ liệu hợp lệ.");
            return;
          }

          const cleanedData = [];
          jsonData.forEach(row => {
            const cellValue = row[0];
            if (cellValue) {
              if (!this.isExistContentByAccountId(cellValue, this.accountIdCreate) 
                  && !cellValue.trim().includes(' ') 
                  && !this.isContainSpecialCharater(cellValue)) {
                cleanedData.push(cellValue);
              }
            }
          });

          this.textContent = cleanedData.join('\n');
          if(this.textContent.length < 1) this.alert("error", "Tất cả từ đã tồn tại.");

        } catch (error) {
          this.alert("error", "Lỗi khi xử lý file");
          console.error('Error reading or processing file:', error);
        }
      };

      if (this.fileList[0] && this.fileList[0].raw) {
        reader.readAsArrayBuffer(this.fileList[0].raw);
      }
    },
    isExistContentByAccountId(content, accountId) {
      if(accountId === '0'){
        return this.app.characterFilters[accountId].some(item => item.content === content);
      }
      else {
        return this.app.characterFilters['0'].some(item => item.content === content) || this.app.characterFilters[accountId].some(item => item.content === content);
      }
    },
    cancelExcelDialog() {
      this.isShowExcelDialog = false;
      this.textContent = "";
    },
    handleCloseExcelDialog(){
      this.textContent = "";
      this.fileList = [];
    }
  },
  created() {
    this.getCharacter();
  }
};
</script>

<style scoped>
.upload >>> .el-upload-list__item-name {
  max-width: 250px !important;
}
</style>
